import React, { Component } from 'react';
import { EUIPage } from '../EUI/EUIPage';
import { DataPeriodeOuverture } from '../../data/DataPeriodeOuverture';

export class ControleDeGestion extends Component {
    /* 20230516 : YD : 2349 
     * ajout de la gestion affichage des onglets en fct de la période d'ouverture : 
     * s'il existe une période ouverte on les rend accéssibles */
    constructor(props) {
        super(props);

        this.state = {
            disabledValidation: true,
            disabledReintegration: true,
            disabledPrevision: true
        };
    }
    componentDidMount() {
        this._chargementDonnees();
    }

    componentDidUpdate(prevProps) {
        if (this.props.periodeOuverte) {
        if (prevProps.periodeOuverte != this.props.periodeOuverte)
            this.setState({
                disabledValidation: false,
                disabledReintegration: false,
                disabledPrevision: false
            });
        }
    }
    //_onOpen = () => {
    //    this._chargementDonnees();
    //}

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true
        });

        let chargementPeriodeOuverture = DataPeriodeOuverture._chargementPeriodeOuvertureEnCours();

        chargementPeriodeOuverture
            .then(responseFetch => {

                if (responseFetch.codeRetour === 0) {

                    this.setState({
                        disabledValidation: responseFetch.reponseAPIobjet == null,
                        disabledReintegration: responseFetch.reponseAPIobjet == null,
                        disabledPrevision: responseFetch.reponseAPIobjet == null
                    });

                }
            });
    }

    render = () => <EUIPage
        baseUrl="/ControleDeGestion"
        onglets={[
            { url: "/Recapitulatif", titre: "Récapitulatif" },
            { url: "/Validation", titre: "Validation", disabled: this.state.disabledValidation },
            { url: "/Reintegration", titre: "Réintegration", disabled: this.state.disabledReintegration },
            { url: "/Previsions", titre: "Prévisions", disabled: this.state.disabledPrevision },
        ]}
    />;

}